import { PICKUP_REVIEW_CONTENT } from '../../content';

export const formatMoreToReviewFooter = (moreCount: number | undefined | null): string | null => {
  if (!moreCount || moreCount < 1) {
    return null;
  }
  return PICKUP_REVIEW_CONTENT.moreToReview(moreCount);
};
